import { Component, inject, computed } from '@angular/core';
import { ToastService } from './toast.service';
import { LayoutService } from '../../../core/services/layout.service';

@Component({
  selector: 'app-toast-stack',
  standalone: true,
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
})
export class ToastComponent {
  private toastService = inject(ToastService);
  private layoutService = inject(LayoutService);

  toasts = computed(() => this.toastService.toasts);
  isMobile = this.layoutService.isMobile;
  dismiss(id: string) {
    this.toastService.dismiss(id);
  }
}
